import React, {useState} from "react";
import {
  Form,
  FormGroup,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Spinner,
  Button,
  Label,
} from "reactstrap";
import PropTypes from "prop-types";

import ModalDocument from "../../Modal/ModalDocument";
import ModalConfirm from "../../Modal/ModalConfirm";
import ModalError from "../../Modal/ModalError";
import { FormattedDate, FormattedTime } from "react-intl";


const Documents = ({
  documents,
  person,
  documentTypes,
  setPersonData,
  services,
  onboarding,
  userSession
}) => {
  const [modalNewDocument, setModalNewDocument] = useState({
    open: false,
    loading: false,
    initial: undefined,
    error: undefined
  });
  const [modalConfirm, setModalConfirm] = useState({
    open: false,
    title: "",
    callback: undefined,
    loading: false
  });
  const [modalError, setModalError] = useState({
    open: false,
    message: "",
  });

  console.log("user session", userSession);
  const toggleModalError = (e, message) => {
    setModalError({
      open: !modalError.open,
      message,
    });
  };

  const handleSaveNewDocument = newDocument => {
    const body = {
      person: {
        PersonId: person.PersonId,
        Documents: [newDocument]
      },
      file: false,
      remove: false
    };
    setModalNewDocument(m => ({
      ...m,
      open: true,
      loading: true
    }));
    if (onboarding){
        const newPerson = {...person};
        let found = false;
        newPerson.Documents = documents.map(d => {
          if (
            parseInt(d.PhysicalPersonDocumentTypeId, 10) ===
            parseInt(newDocument.PhysicalPersonDocumentTypeId, 10)
          ) {
            found = true;
            return {
              ...newDocument
            };
          }
          return {
            ...d,
            PhysicalPersonDocumentIsMain: newDocument.PhysicalPersonDocumentIsMain
              ? false
              : d.PhysicalPersonDocumentIsMain
          };
        });
        if (!found) {
          newPerson.Documents.push({...newDocument});
        }
        if (newDocument.PhysicalPersonDocumentIsMain) {
          newPerson.PhysicalPersonMainDocumentType =
            newDocument.PhysicalPersonDocumentTypeName;
          newPerson.PhysicalPersonMainDocumentNumber =
            newDocument.PhysicalPersonDocumentNumber;
          newPerson.PhysicalPersonMainDocumentTypeId = 
            newDocument.PhysicalPersonDocumentTypeId;
        }
      setModalNewDocument(m => ({
        open: false,
        loading: false,
        initial:  undefined,
        error: undefined
      }));
    const body = {
      OnboardingId: String(onboarding),
      postPerson: newPerson,
    };
      services.fetchNewPerson(body, response => {
        if (response && response.result && response.result.Code === 200) {
          setPersonData(newPerson);
        } else {
          toggleModalError(
            {},
            response && response.result
              ? response.result.Description
              : "Server Error"
          );
        }
      });

    }else{
      const updatedBody = {
        ...body, 
        person: {
          ...body.person, 
          isOnboardingPerson: person.isOnboardingPerson,
        },
      };
    services.fetchAppendPersonNewDocument(updatedBody, response => {
      if (response && response.result) {
        const {result} = response;
        if (response.result.Code === 200) {
          const newPerson = {...person};
          let found = false;
          newPerson.Documents = documents.map(d => {
            if (
              parseInt(d.PhysicalPersonDocumentTypeId, 10) ===
              parseInt(newDocument.PhysicalPersonDocumentTypeId, 10)
            ) {
              found = true;
              return {
                ...newDocument
              };
            }
            return {
              ...d,
              PhysicalPersonDocumentIsMain: newDocument.PhysicalPersonDocumentIsMain
                ? false
                : d.PhysicalPersonDocumentIsMain
            };
          });
          if (!found) {
            newPerson.Documents.push({...newDocument});
          }
          if (newDocument.PhysicalPersonDocumentIsMain) {
            newPerson.PhysicalPersonMainDocumentType =
              newDocument.PhysicalPersonDocumentTypeName;
            newPerson.PhysicalPersonMainDocumentNumber =
              newDocument.PhysicalPersonDocumentNumber;
          }
          setPersonData(newPerson);
        } else {
          toggleModalError(
            {},
            response && response.result
              ? `Error saving Document: ${response.result.Description}`
              : "Server Error"
          );
          setModalNewDocument({
            loading: false,
            open: false,
          });
        }
        setModalNewDocument(m => ({
          open: result.Code !== 200,
          loading: false,
          initial: result.Code !== 200 ? m.initial : undefined,
          error: result.Code !== 200 ? response.result.Description : undefined
        }));
      } else {
        setModalNewDocument(m => ({
          ...m,
          open: true,
          loading: false
        }));
      }
    });
  }
  };

  const handleDeleteFile = documentId => {
    const body = {
      person: {
        PersonId: person.PersonId,
        Documents: [
          {
            PhysicalPersonDocumentTypeId: documentId
          }
        ]
      },
      file: false,
      remove: true
    };
    setModalConfirm(m => ({
      ...m,
      loading: true
    }));
    if (onboarding){
      const newPerson = {...person};
        let index = -1;
        let wasMain = false;
        const newDocuments = [...documents];
        newDocuments.forEach((doc, i) => {
          if (
            parseInt(doc.PhysicalPersonDocumentTypeId, 10) ===
            parseInt(documentId, 10)
          ) {
            index = i;
            wasMain = doc.PhysicalPersonDocumentIsMain;
          }
        });
        if (index > -1) {
          newDocuments.splice(index, 1);
          if (wasMain) {
            newPerson.PhysicalPersonMainDocumentType = "";
            newPerson.PhysicalPersonMainDocumentNumber = "";
          }
        }
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false
        });
        setPersonData({
          ...newPerson,
          Documents: newDocuments
        });
      
      const postPerson = {
        ...person,
        Documents: newDocuments,
      };

  const body2 = {
    OnboardingId: String(onboarding),
    postPerson: postPerson,
  };
    services.fetchNewPerson(body2, response => {
      if (response && response.result && response.result.Code === 200) {
        setPersonData(body2.postPerson);
      } else {
        alert("Server Error")
      }
    });

  }else{
    const updatedBody = {
      ...body, 
      person: {
        ...body.person, 
        isOnboardingPerson: person.isOnboardingPerson,
      },
    };
    services.fetchAppendPersonNewDocument(updatedBody, response => {
      if (response && response.result && response.result.Code === 200) {
        const newPerson = {...person};
        let index = -1;
        let wasMain = false;
        const newDocuments = [...documents];
        newDocuments.forEach((doc, i) => {
          if (
            parseInt(doc.PhysicalPersonDocumentTypeId, 10) ===
            parseInt(documentId, 10)
          ) {
            index = i;
            wasMain = doc.PhysicalPersonDocumentIsMain;
          }
        });
        if (index > -1) {
          newDocuments.splice(index, 1);
          if (wasMain) {
            newPerson.PhysicalPersonMainDocumentType = "";
            newPerson.PhysicalPersonMainDocumentNumber = "";
          }
        }
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false
        });
        setPersonData({
          ...newPerson,
          Documents: newDocuments
        });
      } else {
        toggleModalError(
          {},
          response && response.result
            ? `Error saving Document: ${response.result.Description}`
            : "Server Error"
        );
        setModalConfirm({
          open: false,
          title: "",
          callback: undefined,
          loading: false
        });
      }
    });
  }
  };

  const toggleModalConfirm = id =>
    setModalConfirm(m => {
      const newM = {
        ...m,
        open: !m.open
      };
      if (id) {
        newM.title = "Are you sure you want to remove the selected Document?";
        newM.callback = () => handleDeleteFile(id);
      }
      return newM;
    });

  const handleToggleModalNewDocument = initial =>
    setModalNewDocument(m => ({
      open: !m.open,
      loading: m.loading,
      initial,
      error: undefined
    }));

  if (!documents) {
    return <Spinner />;
  }
  return (
    <div>
      <Form>
        <FormGroup tag="fieldset">
          <ListGroup>
            {documents.map(d => (
              <ListGroupItem key={d.PhysicalPersonDocumentTypeId}>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Type: </Col>
                  <Col>
                    {d.PhysicalPersonDocumentTypeName}
                    {d.PhysicalPersonDocumentIsMain ? "(Main)" : ""}
                  </Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div
                      style={{cursor: "pointer", float: "right"}}
                      onClick={() => handleToggleModalNewDocument(d)}
                    >
                      <i className="fa fa-edit" />
                    </div>}
                  </Col>
                </Row>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Expiration Date: </Col>
                  <Col>
                  {(d.PhysicalPersonDocumentWithoutExpiration || !d.PhysicalPersonDocumentExpirationDate)  && <Label>No Expiration</Label>}
                  {!d.PhysicalPersonDocumentWithoutExpiration && d.PhysicalPersonDocumentExpirationDate &&
                   <FormattedDate value={(d.PhysicalPersonDocumentExpirationDate.indexOf("T") > -1) ? d.PhysicalPersonDocumentExpirationDate : d.PhysicalPersonDocumentExpirationDate  + "T00:00"}/> }
                  </Col>
                  <Col>
                    {userSession.IsReadOnly === false && <div
                      style={{cursor: "pointer", float: "right"}}
                      onClick={() =>
                        toggleModalConfirm(d.PhysicalPersonDocumentTypeId)
                      }
                    >
                      <i className="fa fa-trash" />
                    </div>}
                  </Col>
                </Row>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Country: </Col>
                  <Col>{d.PersonDocumentIssueCountryName}</Col>
                  <Col />
                </Row>
                <Row style={{fontSize: "15px", fontWeight: 500}}>
                  <Col>Number: </Col>
                  <Col>{d.PhysicalPersonDocumentNumber}</Col>
                  <Col />
                </Row>
              </ListGroupItem>
            ))}
          </ListGroup>
        </FormGroup>
      </Form>
      {modalNewDocument.open && (
        <ModalDocument
          {...modalNewDocument}
          onSave={handleSaveNewDocument}
          documentTypes={documentTypes}
          onToggle={handleToggleModalNewDocument}
          services={services}
        />
      )}
      <ModalConfirm
        open={modalConfirm.open}
        toggle={toggleModalConfirm}
        saving={modalConfirm.loading}
        callback={modalConfirm.callback}
        title={modalConfirm.title}
      />
      <ModalError {...modalError} onToggle={toggleModalError} />
      {userSession.IsReadOnly === false && <Button
        onClick={() => handleToggleModalNewDocument()}
        color="primary"
        style={{marginRight: 10}}
      >
        Add New Document
      </Button>}
    </div>
  );
};

Documents.propTypes = {
  documents: PropTypes.array,
  person: PropTypes.object.isRequired,
  documentTypes: PropTypes.array,
  setPersonData: PropTypes.func.isRequired,
  services: PropTypes.object.isRequired
};

Documents.defaultProps = {
  documents: undefined,
  documentTypes: undefined
};

export default Documents;
